// extracted by mini-css-extract-plugin
module.exports = {"container":"contact-module--container--3Kx-_","contactInfo":"contact-module--contact-info--J7Nx5","info":"contact-module--info--12Uk6","hours":"contact-module--hours--zt3cP"};